import { FC } from "react";
import { Link } from "react-router-dom";
import { STAFF_USER_ROUTE } from "../../../../app/router/routes";
import { Calendar } from "../../../../shared/ui/calendar";
import { LoaderSpinner } from "../../../../shared/ui/spinner";
import classes from '../staffPenaltyBonus.module.scss'
import { IPenaltyBonusItem, IPenaltyBonusSummary, PenaltiesBonuses } from "../../../../entities/penaltyBonus";

interface IProps {
    setDate: (startDate: Date | null, endDate: Date | null) => void;
    isLoading: boolean;
    items: IPenaltyBonusItem[];
    summary: IPenaltyBonusSummary | null;
    onDelete: (item: IPenaltyBonusItem) => Promise<void>;
    canDelete?: boolean;
}

export const Data: FC<IProps> = ({setDate, items, isLoading, summary, onDelete, canDelete}) => {

    return (
        <section className={classes.calendarArea}>
            <Calendar onDateRangeSelect={setDate} />
            {
                isLoading
                    ?
                <section className={classes.loader}><LoaderSpinner /></section>
                    :
                (items.length && summary)
                    ?
                <section className={classes.data}>
                    <PenaltiesBonuses
                        items={items}
                        summary={summary}
                        onDelete={onDelete}
                        canDelete={canDelete}
                        bonusLabel="Премирование"
                        penaltyLabel="Депремирование"
                        renderMeta={item => <section className={classes.itemMeta}>
                            <span>Назначил: {item.createdByUserId
                                ? <Link className={classes.staffLink} to={STAFF_USER_ROUTE.path.replace(':user_id', String(item.createdByUserId))}>{item.createdByName || `Сотрудник ${item.createdByUserId}`}</Link>
                                : item.createdByName || '—'}</span>
                            <span>Статус выплаты: {item.isPaid ? 'Выплачено' : 'Не выплачено'}</span>
                        </section>}
                    />
                </section>
                    :
                <></>
            }
        </section>
    )
}
